






















































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import Preview from 'vue-photo-preview'
    import ResultModel from '@/store/entities/nationalLogisticsInfo'
    import EditReturnOrder from '@/views/front/abroad/edit-returnorder.vue'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);


    class PageOrderRequest extends PageRequest {
        //WarehouseOrderStatus?: number ;
        //WarehouseOrderPackageStatus?: number;

        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        BeginTime?: Date;
        EndTime?: Date;
        OrderType?: number;
        cargoCategory?: number;
        PlatformType?: number;
        site?: number;
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            this.OrderType = 1;
            this.PlatformType = null;
            this.site = null;
        }
    }


    @Component({
        name: "mainlandorderlist",
        components: { EditReturnOrder }
    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        siteType = Enums.getEnum(Enums.SiteSType, true);
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        Model: ResultModel = null;
        spinShow: boolean = false;
        editreturnorderModel: boolean = false;
        get list() {
            return this.$store.state.fontmainlandorder.list;
        };
        get loading() {
            return this.$store.state.fontmainlandorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('fontmainlandorder/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('fontmainlandorder/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.fontmainlandorder.currentPage=1;
            this.getpage();
        }
        async handleRowClick(row) {
            var _this = this;
            if (row.waybillNumber != null) {
                this.spinShow = true;
                this.Model =  await this.$store.dispatch({
                    type: 'fontmainlandorder/getResult',
                    data: { number: row.waybillNumber }
                }).finally(() => {
                //    setTimeout(() => {
                //    this.spinShow = false;
                //}, 1000);
                    this.spinShow = false;
                });
                var a = this.Model;
                if (this.Model == null) {
                    this.$Modal.info({
                        title: "提示", content: "没有跟踪信息！", onOk: async () => {
                        }
                    });
                }

                else {
                    if (this.Model.itemInfo != null) {
                        var html = "";
                        var tr = "";
                        var table = "<table style='border:1px solid #0094ff;border-collapse:collapse; cellpadding:2;cellspacing:0;'><tr><td style='border:1px solid #0094ff;'>日期时间</td><td style='border:1px solid #0094ff;'>服务地点</td><td style='border:1px solid #0094ff;'>&#12288;&#12288;详细内容</td></tr>";
                        this.Model.itemInfo.forEach(function (item, index) {
                            tr += "<tr><td style='border:1px solid #0094ff;'>" + item.dateTime + "&#12288;&#12288;</td><td style='border:1px solid #0094ff;'>" + item.serviceSite + "</td><td style='border:1px solid #0094ff;'>&#12288;&#12288;" + item.content +"</td></tr>";
                        })
                        var endtable = "</table>";
                        html = table + tr + endtable;
                        this.$Modal.info({
                            title: "提示", width:800, content: "货运单号：" + this.Model.waybillNumber + "<br />" + "出发地：" + this.Model.leavePlace + " <br />" + "目的地：" + this.Model.purposePlace + " <br /> " + "状态：" + this.Model.status + "<br /><br />" + html, onOk: async () => {
                            }
                        });
                    }
                    else {
                        this.$Modal.info({
                            title: "提示", content: "货运单号：" + this.Model.waybillNumber + "<br />" + "出发地：" + this.Model.leavePlace + " <br />" + "目的地：" + this.Model.purposePlace + " <br /> " + "状态：" + this.Model.status, onOk: async () => {
                            }
                        });
                    }
                  
                }
                
                
              
            };
         
            
        }
        async InputReturnOrder(data: any) {
            this.$store.state.fontoverseasreturnorders.id = data.id;
            this.$store.state.fontoverseasreturnorders.orderNumber = data.orderNumber;
            this.editreturnorderModel = true;
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'fontmainlandorder/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }
        get pageSize() {
            return this.$store.state.fontmainlandorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.fontmainlandorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.fontmainlandorder.currentPage;
        }
        async operationData(name: any, data: any) {
             if (name == '撤销') {
                await this.$store.dispatch({
                    type: 'fontmainlandorder/cancelOrder',
                    data: { id: data.id }
                });
                this.getpage();
            } else if (name == '查看详情') {
                await this.$store.dispatch({
                    type: 'fontmainlandorder/getOrder',
                    data: { id: data.id }
                });
                 this.$store.state.fontmainlandorder.orderStatus = data.orderStatus;
                 this.$router.push({ name: 'frontmainlandorderDetail' });
            } else if (name == '补充运费') {
                await this.$store.dispatch({
                    type: 'fontmainlandorder/supplyFreight',
                    data: { id: data.id }
                });
                 this.$store.state.fontmainlandorder.orderStatus = data.orderStatus;
                this.getpage(); 
            }
             else if (name == '标记为正常') {
                 await this.$store.dispatch({
                     type: 'fontorder/normalOrder',
                     data: { id: data.id }
                 });
                 this.getpage();
             }
        }

        columns = [
            {
                title: '仓库名称',
                key: 'warehouseName',
                width: 150,
            },
            {
                title: '订单信息',
                width: 250,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "订单编号:" + (params.row.orderNumber == null ? "" : params.row.orderNumber)), h('h3', "订单站点:" + (Enums.ShopSiteType.filter(function (item) { return item.value == params.row.site })[0].name)), h('h3', "货物类别:" + (Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name)), h('h3', "订单来源:" + (Enums.PlatformType.filter(function (item) { return item.value == params.row.platformType })[0].name))])
                }
            },
            {
                title: '订单状态',
                width: 100,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            },
            {
                title: '包裹状态',
                width: 120,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name,
                    )
                }
            },
            {
                title: '快递单号',
                key: 'logistics',
                width: 180,
                render: (h: any, params: any) => {
                    return h('div', [h('p', "货运单号：" + (params.row.waybillNumber == null ? "暂无" : params.row.waybillNumber)), h('p', "快递单号："), h('ul', params.row.logistics.map(item => {

                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var shipment = '';
                        var shelfNumber = '';
                        var color = PackageStatus.color;
                        if (item.isReject || item.isReturn) {
                            color = "#ff0000";
                        }
                        var count = '';
                        if (item.shipment) {
                            shipment = item.shipment;
                        }
                        if (item.orderCount > 1) {
                            count = "【" + item.orderCount + "】";
                            //shipment = item.shipment + "【" + item.orderCount + "】";
                        }
                        if (item.shelfNumber) {
                            shelfNumber = "-" + item.shelfNumber + "";
                            //shipment = shipment + "-" + item.shelfNumber;
                        }
                        return h('li', {
                            domProps: {
                                innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + ((color && color.length) > 0 ? "border-left:5px solid " + color + ";padding-left:5px" : "") + '">' + shipment + '<span style="color:red;">' + count + '</span>' + shelfNumber + '</a>'
                            }
                        });
                    }))]
                    )

                }
            },
            {
                title: '运单号',
                key: 'tradeNo',
                width: 150,
            },
            {
                title: '商品信息',
                width: 250,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    var a = "";
                    if (params.row.reMark) {
                        a = 'red';
                    }
                    else {
                        a = 'dark';
                    }
                    return h('div', [
                        h('ul', params.row.orderProductInfoList.map(item => {
                            var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                            return h('li', {
                            }, [
                                h('img', {
                                    attrs: {
                                        class: "img",
                                        src: item.url,
                                        preview: params.row.id,
                                        "preview-text": params.row.orderNumber + "-" + item.productName
                                    }
                                }), item.productLinkAddress ? (h('a', { on: { click: () => { this.JumpToUrl(item.productLinkAddress) } } }, item.productName)) : item.productName, h('font', { style: { color: "red" } }, '*'), item.count]);
                        })), h('h4', { style: { color: a } }, "备注：" + (params.row.reMark == null ? "" : params.row.reMark))
                    ])

                }
            },

            {
                title: '包裹信息',
                width: 250,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "重量重【g】:" + (params.row.heavyWeight == null ? "" : params.row.heavyWeight)), h('h3', "体积重【g】:" + (params.row.bulkyByClient == null ? "" : params.row.bulkyByClient)), h('h3', "实际计算重量【g】:" + (params.row.weight == null ? "" : params.row.weight)), h('h3', "打包袋数量:" + (params.row.sackNums == null ? "" : params.row.sackNums)), h('h3', "基本SKU数量:" + (params.row.baseSkuNums == null ? "" : params.row.baseSkuNums))])
                }
            },

            {
                title: '费用',
                width: 200,
                render: (h: any, params: any) => {
                    var a = "";
                    var b = "";
                    var c = "";
                    var d = "";
                    var e = "";
                    var f = "";
                    if (params.row.isPay) {
                        a = 'red';
                    }
                    else {
                        a = 'dark';
                    }
                    if (params.row.freightCost) {
                        b = 'red';
                    }
                    else {
                        b = 'dark';
                    }
                    if (params.row.extraCost) {
                        c = 'red';
                    }
                    else {
                        c = 'dark';
                    }
                    if (params.row.extraCostDescribe) {
                        d = 'red';
                    }
                    else {
                        d = 'dark';
                    }
                    if (params.row.sackTotalAmount > 0) {
                        e = 'red';
                    }
                    else {
                        e = 'dark';
                    }
                    if (params.row.skuTotalAmount > 0) {
                        f = 'red';
                    }
                    else {
                        f = 'dark';
                    }
                    return h('div', [h('h3', { style: { color: a } }, "是否支付:" + (params.row.isPay ? this.L('是') : this.L('否'))), h('h3', { style: { color: b } }, "运费【积分】:" + (params.row.freightCost == null ? "" : params.row.freightCost)), h('h3', { style: { color: c } }, "额外消费【积分】:" + (params.row.extraCost == null ? "" : params.row.extraCost)), h('h3', { style: { color: d } }, "额外消费说明:" + (params.row.extraCostDescribe == null ? "" : params.row.extraCostDescribe)), h('h3', { style: { color: e } }, "打包袋金额:" + (params.row.sackTotalAmount == null ? "" : params.row.sackTotalAmount)), h('h3', { style: { color: f } }, "SKU金额:" + (params.row.skuTotalAmount == null ? "" : params.row.skuTotalAmount))])
                }
            },
            {
                title: '退件订单编号',
                width: 120,
                key: 'returnNumber',
            },
            {
                title: '称重上传图片',
                key: 'weightImageUploadGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.weightImageUploadGuid) {
                        var data = { imageGuid: params.row.weightImageUploadGuid, url: null };
                        this.$store.commit('backlogistics/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id + "*",
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            }, {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('backlogistics/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id + "//",
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },

            //{
            //    title: '订单编号',
            //    key: 'orderNumber',
            //    width: 150,
            //    fixed: 'left',
            //}, {
            //    title: '订单状态',
            //    width: 150,
            //    key: 'orderStatus',
            //    render: (h: any, params: any) => {
            //        var warehouseNote = params.row.warehouseNote;
            //        if (warehouseNote) {
            //            warehouseNote = "(" + warehouseNote + ")";
            //        }
            //        else {
            //            warehouseNote = "";
            //        }
            //        return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
            //        )
            //    }
            //}, {
            //    title: '货物类别',
            //    width: 90,
            //    key: 'cargoCategory',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
            //    }
            //},
            //{
            //    title: '店铺站点',
            //    width: 90,
            //    key: 'site',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
            //    }
            //}, {
            //    title: '包裹状态',
            //    width: 120, 
            //    key: 'packageStatus',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
            //    }
            //},
            //{
            //    title: '错误信息',
            //    key: 'mistakeinfomation',
            //    width: 150,
            //     render: (h: any, params: any) => {
            //         return h('div', [h('span', { style: { color: 'red' } }, params.row.mistakeinfomation)]
            //        )
            //    }
            //},
            //{
            //    title: '货运单号',
            //    key: 'waybillNumber',
            //    width: 120,
            //},
            //{
            //    title: '重量重【g】',
            //    key: 'heavyWeight',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.heavyWeight == null ? "" : params.row.heavyWeight)
            //    }
            //},
            //{
            //    title: '体积重【g】',
            //    key: 'bulkyByClient',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.bulkyByClient == null ? "" : params.row.bulkyByClient)
            //    }
            //},
            //{
            //    title: '实际计算重量【g】',
            //    key: 'weight',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.weight == null ? "" : params.row.weight)
            //    }
            //}, {
            //    title: '运费',
            //    key: 'freightCost',
            //    width: 120,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.freightCost == 0 ? "" : params.row.freightCost)
            //    }
            //},
            //{
            //    title: '额外消费',
            //    key: 'extraCost',
            //    width: 120,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.extraCost == 0 ? "" : params.row.extraCost)
            //    }
            //},
            //{
            //    title: '额外消费说明',
            //    width: 200,
            //    key: 'extraCostDescribe',
            //}, 
            //{
            //    title: '是否支付',
            //    key: 'isPay',
            //    width: 120,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.isPay ? this.L('是') : this.L('否'))
            //    }
            //},
            //{
            //    title: '称重上传图片',
            //    key: 'weightImageUploadGuid',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        if (params.row.weightImageUploadGuid) {
            //            var data = { imageGuid: params.row.weightImageUploadGuid, url: null };
            //            this.$store.commit('backlogistics/getImgUrl', data);
            //            var url = data.url;;
            //            return h('img', {
            //                style: {
            //                    width: "50px",
            //                    height: "50px",
            //                    verticalAlign: "middle"
            //                },
            //                attrs: {
            //                    src: url,
            //                    preview: params.row.id + "*",
            //                    "preview-text": params.row.orderNumber
            //                }
            //            });

            //        } else {
            //            return h('span', "");
            //        }
            //    }
            //},{
            //    title: '异常图片',
            //    key: 'abnormalImageUploadGuid',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        if (params.row.abnormalImageUploadGuid) {
            //            var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
            //            this.$store.commit('expressuserinfo/getImgUrl', data);
            //            var url = data.url;;
            //            return h('img', {
            //                style: {
            //                    width: "50px",
            //                    height: "50px",
            //                    verticalAlign: "middle"
            //                },
            //                attrs: {
            //                    src: url,
            //                    preview: params.row.id+"^",
            //                    "preview-text": params.row.orderNumber
            //                }
            //            });

            //        } else {
            //            return h('span', "");
            //        }
            //    }
            //},
            {
                title: '时间类型',
                key: '',
                width: 220,
                render: (h: any, params: any) => {
                    return h('div', [
                        h('h4', "创建时间：" + (params.row.createTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.createTime)))), h('h4', "送仓时间：" + (params.row.arriveWarehouseTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime))))
                    ]);
                }
            },
            //{
            //    title: '创建时间',
            //    key: 'createTime',
            //    width: 100,
            //    render: (h: any, params: any) => {
            //        return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
            //    }
            //},
            //{
            //    title: '送仓时间',
            //    key: 'arriveWarehouseTime',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
            //    }
            //},
            //{
            //    title: '快递单号',
            //    key: 'logistics',
            //    width: 200,
            //    render: (h: any, params: any) => {
            //        return h('ul', params.row.logistics.map(item => {
            //            var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
            //            return h('li', {
            //                domProps: {
            //                    innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + (PackageStatus.color.length > 0 ? "border-left:5px solid " + PackageStatus.color + ";padding-left:5px" : "") + '">' + item.shipment + '</a>'
            //                }
            //            });
            //        }));
            //    }
            //}, {
            //    title: '商品信息',
            //    width: 600,
            //    key: 'orderProductInfoList',
            //    render: (h: any, params: any) => {
            //        var _this = this;
            //        return h('ul', params.row.orderProductInfoList.map(item => {
            //            var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
            //            return h('li', {
            //            }, [
            //                h('img', {
            //                    attrs: {
            //                        class: "img",
            //                        src: item.url,
            //                        preview: params.row.id,
            //                        "preview-text": params.row.orderNumber + "-" + item.productName
            //                    }
            //                }), item.productLinkAddress ? (h('a', { on: { click: () => { this.JumpToUrl(item.productLinkAddress) } } }, item.productName)) : item.productName, h('font', { style: { color: "red" } }, '*'), item.count]);
            //        }));
            //    }
            //}, {
            //    title: '备注',
            //    width: 200,
            //    key: 'reMark',
            //},
            //{
            //    title: '打包袋数量',
            //    key: 'sackNums',
            //    width: 80,
            //},
            //{
            //    title: '基本SKU数量',
            //    key: 'baseSkuNums',
            //    width: 80,
            //},
            //{
            //    title: '打包袋金额',
            //    key: 'sackTotalAmount',
            //    width: 80,
            //},
            //{
            //    title: 'SKU金额',
            //    key: 'skuTotalAmount',
            //    width: 80,
            //},
            {
                title: '操作',
                width: 120,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var _this = this;
                    var menu = [];
                    var data = params.row;
                    if (params.row.packageStatus == 0 && params.row.orderStatus == 0 || params.row.orderStatus == -1) {
                        menu.push("撤销");
                    } if (params.row.packageStatus == 7 && params.row.orderStatus == 0) {
                        menu.push("补充运费");
                    }
                    if (params.row.orderStatus == -1) {
                        menu.push("标记为正常");
                    }
                    menu.push("查看详情");
                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    },
                                    style: {
                                        marginTop: '5px',
                                        height: '30px',
                                        width: '85px',
                                    },

                                }),
                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )]),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                                display: (data.orderStatus == 0) ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.InputReturnOrder(data);

                                }
                            }

                        }, "编辑退件订单"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                                        this.$store.commit('fontorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),

                    ]);
                }
            }]
        JumpToUrl(val: string) {
            window.open(val, '_blank')
        }
        async created() {
            var abnormal = abp.getQueryVariable("abnormal");
            if (abnormal && abnormal == 'true') {
                this.pagerequest.orderStatus = -1;
            }
            this.getpage();
        }
    }
